export function renderCardForm() {
    const form = document.createElement('form');

    // Card Number field
    const cardNumberLabel = document.createElement('label');
    cardNumberLabel.innerText = 'Card Number: ';
    const cardNumberInput = document.createElement('input');
    cardNumberInput.type = 'text';
    cardNumberInput.name = 'cardNumber';
    cardNumberInput.placeholder = 'Enter card number';
    form.appendChild(cardNumberLabel);
    form.appendChild(cardNumberInput);

    form.appendChild(document.createElement('br'));

    // Expiry Date field
    const expiryDateLabel = document.createElement('label');
    expiryDateLabel.innerText = 'Expiry Date: ';
    const expiryDateInput = document.createElement('input');
    expiryDateInput.type = 'text';
    expiryDateInput.name = 'expiryDate';
    expiryDateInput.placeholder = 'MM/YY';
    form.appendChild(expiryDateLabel);
    form.appendChild(expiryDateInput);

    form.appendChild(document.createElement('br'));

    // CVV field
    const cvvLabel = document.createElement('label');
    cvvLabel.innerText = 'CVV: ';
    const cvvInput = document.createElement('input');
    cvvInput.type = 'password';
    cvvInput.name = 'cvv';
    cvvInput.placeholder = 'Enter CVV';
    form.appendChild(cvvLabel);
    form.appendChild(cvvInput);

    form.appendChild(document.createElement('br'));

    // Submit Button
    const submitButton = document.createElement('button');
    submitButton.type = 'submit';
    submitButton.innerText = 'Submit Payment';
    form.appendChild(submitButton);

    // Handle form submission (for now, just log card details)
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        const cardNumber = cardNumberInput.value;
        const expiryDate = expiryDateInput.value;
        const cvv = cvvInput.value;
        console.log('Card Number:', cardNumber);
        console.log('Expiry Date:', expiryDate);
        console.log('CVV:', cvv);
    });

    return form;
}
